import React from 'react';

const Story = ({currentLanguage, translate, title, content, btn}) => (
	<div className="person-about">
		<h3 className="about-subtitle">{translate(title)}</h3>
		<p>{translate(content)}</p>
		<a className="btn waves-effect waves-light"
		   href={require(`../../../assets/files/cv/christhoval_barba_${currentLanguage}.pdf`)}
		   download>
			<i className="mdi mdi-download left">
				{translate(btn)}
			</i>
		</a>
	</div>
);

export default Story;



// WEBPACK FOOTER //
// ./src/components/elements/About/Story.js